
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/language",
      function () {
        return require("private-next-pages/language.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/language"])
      });
    }
  